/* NukkadTales — Gul Sprite System v7
   Depends on: window.NT_GUL_SPR (sprite sheet URL, set by theme layout)
   Exports: window.NT = { F, wait, chirp, flapSnd, makeGul, blinkLoop }
*/
(function () {
  'use strict';

  /* Frame indices — 13 frames, each D×D px */
  const F = {
    closed:0, open:1, blink:2, happy:3, wup:4, wdn:5,
    fup:6, fdn:7, gld:8, sit:9, peck:10, preen:11, fluff:12
  };

  const wait = ms => new Promise(res => setTimeout(res, ms));

  /* Audio */
  let AC = null;
  function ac() {
    if (!AC) {
      try { AC = new (window.AudioContext || window.webkitAudioContext)(); } catch(e) {}
    }
    if (AC && AC.state === 'suspended') AC.resume();
    return AC;
  }
  const VOL = (matchMedia && matchMedia('(pointer:coarse)').matches) ? 1.8 : 1;

  function unlockAudio() {
    const a = ac(); if (!a) return;
    if (a.state === 'suspended') a.resume();
    try {
      const b = a.createBuffer(1,1,22050), sb = a.createBufferSource();
      sb.buffer = b; sb.connect(a.destination); sb.start(0);
    } catch(e) {}
    if (a.state === 'running') {
      ['pointerdown','touchstart','touchend','click','wheel','keydown']
        .forEach(ev => removeEventListener(ev, unlockAudio));
      const ic = document.getElementById('nt-sndIco');
      if (ic) { ic.style.opacity = '0'; setTimeout(() => ic.remove(), 600); }
    }
  }
  ['pointerdown','touchstart','touchend','click','wheel','keydown'].forEach(ev => {
    addEventListener(ev, unlockAudio, ev === 'touchstart' ? { passive: true } : undefined);
  });

  function chirp() {
    const a = ac(); if (!a || a.state !== 'running') return;
    const t = a.currentTime, f = 2300 + Math.random() * 900;
    const o = a.createOscillator(), g2 = a.createGain();
    o.type = 'sine';
    o.frequency.setValueAtTime(f, t);
    o.frequency.exponentialRampToValueAtTime(f * 1.6, t + 0.032);
    o.frequency.exponentialRampToValueAtTime(f * 0.82, t + 0.066);
    g2.gain.setValueAtTime(0.0001, t);
    g2.gain.exponentialRampToValueAtTime(0.048 * VOL, t + 0.01);
    g2.gain.exponentialRampToValueAtTime(0.0001, t + 0.075);
    o.connect(g2); g2.connect(a.destination); o.start(t); o.stop(t + 0.09);
  }

  function flapSnd() {
    const a = ac(); if (!a || a.state !== 'running') return;
    const t = a.currentTime, dur = 0.09;
    const buf = a.createBuffer(1, a.sampleRate * dur | 0, a.sampleRate);
    const d = buf.getChannelData(0);
    for (let i = 0; i < d.length; i++) d[i] = (Math.random() * 2 - 1) * (1 - i / d.length);
    const src = a.createBufferSource(); src.buffer = buf;
    const bp = a.createBiquadFilter(); bp.type = 'bandpass'; bp.frequency.value = 620; bp.Q.value = 0.9;
    const g3 = a.createGain();
    g3.gain.setValueAtTime(0.05 * VOL, t);
    g3.gain.exponentialRampToValueAtTime(0.0001, t + dur);
    src.connect(bp); bp.connect(g3); g3.connect(a.destination); src.start(t);
  }

  /* Bubble measurement helper — script may run async before <body> exists */
  const meas = document.createElement('div');
  meas.style.cssText = 'position:fixed;left:-9999px;top:0;visibility:hidden;pointer-events:none;';
  if (document.body) document.body.appendChild(meas);
  else document.addEventListener('DOMContentLoaded', function () { document.body.appendChild(meas); });
  let _bw = 0, _bh = 0;

  function getBubble() { return document.getElementById('nt-bubble'); }
  function getBtext() { return document.getElementById('nt-btext'); }

  function sizeFor(html) {
    const bubble = getBubble(), btext = getBtext();
    if (!bubble || !btext) return;
    meas.style.font = getComputedStyle(btext).font;
    meas.style.fontFamily = getComputedStyle(btext).fontFamily;
    meas.style.fontSize = getComputedStyle(btext).fontSize;
    meas.style.lineHeight = getComputedStyle(btext).lineHeight;
    meas.innerHTML = html;
    const MAXW = parseFloat(getComputedStyle(bubble).maxWidth) || 265;
    meas.style.whiteSpace = 'nowrap'; meas.style.width = 'auto';
    const cW = Math.max(34, Math.min(meas.offsetWidth + 2, MAXW - 34));
    meas.style.whiteSpace = 'normal'; meas.style.width = cW + 'px';
    const cH = meas.offsetHeight;
    _bw = Math.min(cW + 34, MAXW); _bh = cH + 26;
    bubble.style.width = _bw + 'px'; bubble.style.height = _bh + 'px';
  }

  let speaking = null;

  function makeGul(root, D) {
    if (!root) return null;
    const flip = root.querySelector('.gul-flip');
    const leanEl = root.querySelector('.gul-lean');
    const sp = root.querySelector('.gul-sprite');
    if (!flip || !leanEl || !sp) return null;

    const SPR = window.NT_GUL_SPR || '';
    if (SPR) {
      /* Override the Liquid-inlined URL only when the JS-side URL is available */
      sp.style.setProperty('--spr', `url('${SPR}')`);
      sp.style.backgroundImage = `url('${SPR}')`;
    }
    /* If SPR is empty, keep whatever background-image was inlined in HTML */
    sp.style.backgroundRepeat = 'no-repeat';
    sp.style.backgroundSize = (D * 13) + 'px ' + D + 'px';
    root.style.setProperty('--D', D + 'px');
    root.style.width = D + 'px';
    root.style.height = D + 'px';

    const g = { root, sp, flip, leanEl, D, base: F.closed, run: 0, mouthT: null };

    g.frame = function(i) {
      var d = g.D || D;
      sp.style.width = d + 'px';
      sp.style.height = d + 'px';
      sp.style.backgroundPosition = (-i * d) + 'px 0';
      sp.style.backgroundSize = (d * 13) + 'px ' + d + 'px';
    };
    g.setFace = f => { g.base = f; g.frame(f); };
    g.mouth = on => {
      if (g.mouthT) { clearInterval(g.mouthT); g.mouthT = null; }
      if (!on) { g.frame(g.base); return; }
      let t = 0;
      g.mouthT = setInterval(() => { t ^= 1; g.frame(t ? F.open : g.base); }, 135);
    };
    g.lean = d => { leanEl.style.transform = `rotate(${d}deg)`; };

    g.gest = async c => {
      if (c === 'blink') { g.frame(F.blink); await wait(135); g.frame(g.base); }
      else if (c === 'blink2') {
        g.frame(F.blink); await wait(95); g.frame(g.base);
        await wait(85); g.frame(F.blink); await wait(125); g.frame(g.base);
      }
      else if (c === 'wings') { g.frame(F.wup); await wait(240); g.frame(g.base); }
      else if (c === 'wave') {
        for (let wi = 0; wi < 2; wi++) { g.frame(F.wup); await wait(190); g.frame(F.wdn); await wait(150); }
        g.frame(g.base);
      }
      else if (c === 'giggle') {
        g.setFace(F.happy);
        for (let i = 0; i < 3; i++) { flip.classList.add('gigA'); await wait(300); flip.classList.remove('gigA'); await wait(40); }
        await wait(420); g.setFace(F.closed);
      }
      else if (c === 'tilt') { g.lean(8); await wait(380); }
      else if (c === 'lean') { g.lean(5); await wait(80); }
      else if (c === 'settle') { g.lean(0); g.setFace(F.closed); await wait(130); }
      else if (c === 'pause') { g.mouth(false); await wait(440); }
      else if (c === 'chirp') { chirp(); }
    };

    /* cache header element once — never query it in the hot rAF path */
    let _hdrEl, _hdrElChecked = false;
    function _getHdr() {
      if (!_hdrElChecked) {
        _hdrEl = document.querySelector('.section-header, .shopify-section-group-header-group, header[id]');
        _hdrElChecked = true;
      }
      return _hdrEl;
    }

    /* rAF loop at ~20fps — keeps bubble glued to Gul through parallax without thrashing layout */
    let _tid = 0, _tframe = 0;
    function _track(id) {
      if (id !== _tid) return;
      const bbl = getBubble();
      if (!bbl || !bbl.classList.contains('show')) return;
      if ((++_tframe & 2) === 0) g.bubblePos(); /* every 3rd frame ≈ 20fps */
      requestAnimationFrame(function(){ _track(id); });
    }
    function _startTrack() {
      const id = ++_tid;
      requestAnimationFrame(function(){ _track(id); });
    }

    g.instant = function(text) {
      const bubble = getBubble(), btext = getBtext();
      if (!bubble || !btext) return;
      g.run++;
      btext.innerHTML = text;
      sizeFor(text);
      /* sizeFor sets an explicit height which can clip text if the font renders
         taller than the off-screen meas element measured (e.g. Kalam ascenders).
         Clear it so the bubble auto-sizes to its actual content, then sync _bh
         so bubblePos() positions correctly. CSS transitions from explicit→auto
         are unsupported, so the jump is immediate (no visible artifact). */
      bubble.style.height = 'auto';
      const naturalH = bubble.offsetHeight;
      if (naturalH > 0) _bh = naturalH;
      g.bubblePos(true);
      _startTrack();
    };

    g.bubblePos = reset => {
      const bubble = getBubble(); if (!bubble) return;
      const tail = bubble.querySelector('.tail');
      const rr = sp.getBoundingClientRect();
      const scrollY = window.pageYOffset || 0;
      const gx = rr.left + rr.width / 2;
      const bw = _bw || bubble.offsetWidth;
      const bh = _bh || bubble.offsetHeight || 90;
      /* clear space below the sticky header (cached — no querySelector in hot path) */
      const hdrEl = _getHdr();
      const minTopVp = hdrEl ? hdrEl.getBoundingClientRect().bottom + 6 : 8;
      if (reset || !g._bm) {
        g._bm = (rr.top - bh - 12 >= minTopVp) ? 'above' : 'below';
        bubble.classList.toggle('b-above', g._bm === 'above');
        bubble.classList.toggle('b-below', g._bm === 'below');
        g._bx = null;
      }
      /* position:absolute — convert viewport coords to document coords via +scrollY */
      let bx = Math.max(8, Math.min(gx - bw / 2, window.innerWidth - bw - 8));
      if (g._bx === null || Math.abs(bx - g._bx) > 6) { g._bx = bx; bubble.style.left = bx + 'px'; }
      if (tail) tail.style.left = Math.max(14, Math.min(gx - g._bx - 6, bw - 26)) + 'px';
      if (g._bm === 'above') {
        bubble.style.bottom = 'auto';
        bubble.style.top = (scrollY + Math.max(minTopVp, rr.top - bh - 12)) + 'px';
      } else {
        bubble.style.bottom = 'auto';
        bubble.style.top = (scrollY + rr.bottom + 12) + 'px';
      }
      bubble.classList.add('show');
    };

    g.tell = async text => {
      const bubble = getBubble(), btext = getBtext(); if (!bubble || !btext) return;
      if (speaking && speaking !== g) speaking.mouth(false);
      speaking = g;
      g.run++; const id = g.run;
      /* Dismiss if Gul scrolls off-screen; rAF loop handles repositioning */
      const onScroll = () => {
        if (id !== g.run || !bubble.classList.contains('show')) {
          window.removeEventListener('scroll', onScroll); return;
        }
        const rr = sp.getBoundingClientRect();
        if (rr.bottom < -20 || rr.top > window.innerHeight + 20) {
          g.run++; g.mouth(false); bubble.classList.remove('show');
          window.removeEventListener('scroll', onScroll);
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      g.lean(0); g.setFace(F.closed); g._bm = null;

      /* parse {tokens} and split into chunks */
      const segs = [];
      const re = /\{(\w+)\}/g; let last = 0, m;
      while ((m = re.exec(text))) {
        if (m.index > last) segs.push({ t: 't', v: text.slice(last, m.index) });
        segs.push({ t: 'c', v: m[1] });
        last = re.lastIndex;
      }
      if (last < text.length) segs.push({ t: 't', v: text.slice(last) });

      const chunks = []; let cur = []; let cnt = 0;
      for (const sg of segs) {
        if (sg.t === 'c') { cur.push(sg); continue; }
        let buf = '', i = 0; const tx = sg.v;
        while (i < tx.length) {
          const ch = tx[i];
          if (ch === '&') { const j = tx.indexOf(';', i); buf += tx.slice(i, j + 1); i = j + 1; cnt++; continue; }
          if (ch === '<') { const j = tx.indexOf('>', i); buf += tx.slice(i, j + 1); i = j + 1; continue; }
          buf += ch; i++; cnt++;
          if (cnt > 55 && '.!?'.includes(ch) && (i >= tx.length || tx[i] === ' ')) {
            cur.push({ t: 't', v: buf }); chunks.push(cur); cur = []; buf = ''; cnt = 0;
            while (i < tx.length && tx[i] === ' ') i++;
          }
        }
        if (buf) cur.push({ t: 't', v: buf });
      }
      if (cur.length) chunks.push(cur);

      for (let ci = 0; ci < chunks.length; ci++) {
        if (id !== g.run) return;
        const chunk = chunks[ci];
        const full = chunk.filter(x => x.t === 't').map(x => x.v).join('');
        btext.innerHTML = ''; let lastCh = ''; let shown = false;
        const grow = () => { if (!shown) { shown = true; g.bubblePos(true); _startTrack(); } };

        if (full.trim()) { sizeFor(full); bubble.style.width = _bw + 'px'; bubble.style.height = _bh + 'px'; }

        for (const sg of chunk) {
          if (id !== g.run) return;
          if (sg.t === 'c') { await g.gest(sg.v); continue; }
          g.mouth(true); let i = 0; const tx = sg.v;
          let nextAt = performance.now();
          while (i < tx.length) {
            if (id !== g.run) return;
            const ch = tx[i];
            if (ch === '<') { const j = tx.indexOf('>', i); btext.innerHTML += tx.slice(i, j + 1); i = j + 1; continue; }
            if (ch === '&') {
              const j = tx.indexOf(';', i); const ent = tx.slice(i, j + 1);
              btext.innerHTML += ent; i = j + 1; grow();
              if (ent === '&mdash;') { g.mouth(false); await wait(340); g.mouth(true); nextAt = performance.now(); }
              else if (ent === '&hellip;') { g.mouth(false); await wait(500); g.mouth(true); nextAt = performance.now(); }
              else { nextAt += 28; const d = nextAt - performance.now(); if (d > 4) await wait(d); }
              continue;
            }
            if (ch === ' ' && btext.innerHTML === '') { i++; continue; }
            btext.innerHTML += ch; i++; lastCh = ch; grow();
            if ('aeiouAEIOU'.includes(ch) && Math.random() < 0.85) chirp();
            if (ch === ',') { g.mouth(false); await wait(260); g.mouth(true); nextAt = performance.now(); }
            else if ('.!?'.includes(ch) && (i >= tx.length || tx[i] === ' ')) { g.mouth(false); await wait(440); g.mouth(true); nextAt = performance.now(); }
            else { nextAt += 48; const d = nextAt - performance.now(); if (d > 4) await wait(d); }
          }
          g.mouth(false);
        }

        if (ci < chunks.length - 1) {
          await wait(lastCh === '?' ? 1400 : 380);
          if (id !== g.run) return;
          bubble.classList.remove('show'); await wait(240);
          if (id !== g.run) return;
          g.frame(F.blink); await wait(130); g.frame(g.base);
        }
      }

      window.removeEventListener('scroll', onScroll);
      g.lean(0);
      if (!btext.textContent.trim()) {
        bubble.classList.remove('show');
      } else {
        const stay = Math.min(2000, 1400 + btext.textContent.length * 8);
        setTimeout(() => { if (id === g.run) bubble.classList.remove('show'); }, stay);
      }
    };

    g.frame(F.closed);
    return g;
  }

  function blinkLoop(g) {
    setInterval(async () => {
      const bubble = getBubble();
      if (speaking === g && bubble && bubble.classList.contains('show')) return;
      g.frame(F.blink); await wait(135); g.frame(g.base);
    }, 5600 + Math.random() * 2000);
  }

  /* Expose on window.NT_GUL namespace */
  window.NT_GUL = { F, wait, chirp, flapSnd, makeGul, blinkLoop };

  /* Also alias for home wiring */
  window.F = F;
  window.wait = wait;
  window.chirp = chirp;
  window.flapSnd = flapSnd;
  window.makeGul = makeGul;
  window.blinkLoop = blinkLoop;
  window.ntSpeaking = () => speaking;
})();
